import { Col, Container, Row } from 'reactstrap';
import { useDelayUnmount, useModal, useTheme } from 'Hooks';
import {
	ProfileStatisticCard,
	LoadingSpinner,
	ReactSwitch,
	FontAwesome,
	Button,
	ModalBoxSectionEditProfile,
	Collapsible,
	ProfileAddNewCard,
	ModalBoxAddStatistic,
	ModalBoxDelete
} from 'Elements';
import styles from 'partials/homepage/section/profile-hero-header.module.scss';
import { useTranslation } from 'react-i18next';
import { Colors, Statistic } from 'Types';
import { useState } from 'react';

type Props = {
	isLoadingProfile: boolean;
	isFetchingProfile: boolean;
	statisticItems: Statistic[];
	color: number;
	onChangeValue: (
		objKey: string,
		key: string,
		value: string | boolean
	) => void;
	statistics: {
		enabled: boolean;
	};
};

export const CommunityPartnerStatisticSection = ({
	isLoadingProfile,
	onChangeValue,
	color,
	statisticItems,
	statistics
}: Props) => {
	const { t } = useTranslation();
	const { theme } = useTheme();
	const [selectedStatistic, setSelectedStatistic] = useState<any>();
	const [openModalAdd, toggleModalAdd] = useModal();
	const [loadingRemove, setLoadingRemove] = useState(false);
	const [openModalDelete, toggleModalDelete] = useModal();
	const shouldRenderModal = useDelayUnmount(openModalAdd, 350);
	const shouldRenderModalDelete = useDelayUnmount(openModalDelete, 350);
	const [openModal, toggleModal] = useModal();

	const handleRemove = async () => {
		setLoadingRemove(true);
		const newList: any = [];
		statisticItems?.forEach((item) => {
			if (
				selectedStatistic?.title + selectedStatistic?.text !==
				item.title + item?.text
			) {
				newList.push(item);
			}
		});
		onChangeValue('statisticItems', '', newList as any);
		setLoadingRemove(false);
		toggleModalDelete();
	};

	return (
		<section className="position-relative mb-5 mt-6">
			<Container>
				{isLoadingProfile && (
					<div className="d-flex align-items-center justify-content-center my-4 py-4">
						<LoadingSpinner />
					</div>
				)}
				{!isLoadingProfile && statistics && (
					<Collapsible
						header={
							<div
								className={`d-flex flex-wrap gap-3 align-items-center justify-content-between mb-3 ${styles.switcherBox}`}>
								<div className="d-flex flex-wrap align-items-center gap-3">
									<h5 className="fs-5 fw-700">
										{' '}
										{t('text.statistics')}
									</h5>
									<ReactSwitch
										size="md"
										checked={statistics?.enabled}
										onChange={(val: boolean) => {
											onChangeValue(
												'statistics',
												'enabled',
												val
											);
										}}
									/>
									<span className="d-flex align-items-center mb-0 py-0 cursor-pointer">
										{t('forms.show-statistic-in-home')}
									</span>
								</div>
								<div>
									<Button
										size="sm"
										color={Colors['white-gray']}
										onClick={() => toggleModal()}>
										<FontAwesome
											icon="circle-info"
											size="1x"
											className="text-gray me-1"
										/>
										{t('button.more')}
									</Button>
								</div>
							</div>
						}>
						<Row>
							<Col sm={6} md={3} className="mb-4">
								<ProfileAddNewCard
									onClick={() => {
										setSelectedStatistic(null);
										toggleModalAdd();
									}}
									navigationUrl=""
									size="sm"
									title="title.add-new-statistic"
								/>
							</Col>
							{statisticItems?.map((item) => {
								return (
									<Col
										key={item.title + item.text}
										sm={6}
										md={3}
										className="mb-4">
										<ProfileStatisticCard
											isEdit={true}
											icon={item.icon}
											fill={
												color?.toString() ??
												theme.businessPartner
													.primaryColor
											}
											title={item.title}
											desc={item.text}
											item={item}
											onClick={() => {
												setSelectedStatistic(item);
											}}
											toggleModalDelete={
												toggleModalDelete
											}
											toggleModalAdd={toggleModalAdd}
										/>
									</Col>
								);
							})}
						</Row>
					</Collapsible>
				)}
			</Container>
			{!isLoadingProfile && !statistics?.enabled && (
				<div className="overlay overlay_white overlay-box" />
			)}
			{shouldRenderModal && (
				<ModalBoxAddStatistic
					isOpen={openModalAdd}
					statisticItems={statisticItems}
					onChangeValue={onChangeValue}
					onClose={toggleModalAdd}
					title={
						selectedStatistic
							? t('title.edit-statistic')
							: t('title.add-statistic')
					}
					selectedStatistic={selectedStatistic}
				/>
			)}
			{shouldRenderModalDelete && (
				<ModalBoxDelete
					isOpen={openModalDelete}
					onClose={toggleModalDelete}
					onRemove={handleRemove}
					isRemoving={loadingRemove}
					title={selectedStatistic?.title ?? ''}
				/>
			)}
			<ModalBoxSectionEditProfile
				isOpen={openModal}
				onClose={toggleModal}
				title="info.statistics-title"
				description="info.statistics-description"
			/>
		</section>
	);
};
